import React, { useEffect, useRef, useState, useMemo } from 'react';
import MiddlewareLogin from '../../../../routers/MiddlewareLogin';
import Axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { CatalogoAPI } from '../../../../shared/http-requests';
import {
    ModalConstructor,
    SpinnerConstructor,
    Footer,
} from '../../../../shared/components';
import {APIHelper, LayoutHelper} from '../../../../shared/helpers';
import AccessibilityBar from '../../../consulta-acessibilidade/AccessibilityBar';
import AccessibilityContextProvider from '../../../consulta-acessibilidade/contexts/AccessibilityContext';
import { StyleHelper } from "../../../../shared/helpers/StyleHelper";
import MobileLayout from './MobileLayout';
import { useAppContext } from '../../../../shared/contexts/AppContextProvider';
import ContentDetails from '../../components/ContentDetails';
import AutoAtendimento from '../../components/BaseTemplate/AutoAtendimento';

const SearchBar = React.lazy(() =>
    import('../../components/SearchBar/SearchBar'),
);
const GuiasConteudoPersonalizado = React.lazy(() =>
    import('../../components/BaseTemplate/GuiasConteudoPersonalizado'),
);
const InfoAsks = React.lazy(() =>
    import('../../components/BaseTemplate/InfoAsks'),
);

const Div = React.lazy(() => import('../../components/html/Div'));
const Go2Top = React.lazy(() => import('../../components/html/Go2Top'));
const MenuUsuario = React.lazy(() => import('../../components/MenuUsuario'));
const Secoes = React.lazy(() => import('../../components/Home/Secoes'));

function BaseTemplate({
    extras = true,
    showSearchBar = true,
    showHighlights = true,
    userLocalRx,
    userSessionRx,
    logoById = null,
    view,
    ...props
}) {
    const user = userLocalRx || userSessionRx;

    const [renovar, setRenovar] = useState(false);
    const contentRef = useRef(null);
    const {setMobileView,
        mobileView,
        setSectionsData,
        sectionsData,
        isMobile,
    } = useAppContext();

    const navigate = useNavigate();
    const location = useLocation();

    const addSearchParam = (key, value) => {
        const searchParams = new URLSearchParams(location.search);
        searchParams.set(key, value);
        navigate(`${location.pathname}?${searchParams.toString()}`);
    };

    const removeSearchParam = (key) => {
        const searchParams = new URLSearchParams(location.search);
        searchParams.delete(key);
        navigate(`${location.pathname}?${searchParams.toString()}`);
    };

    useEffect(() => {
        if (isMobile) {
            if(mobileView === null){
                removeSearchParam('mobileView');
            }else{
                addSearchParam('mobileView', mobileView);
            }
        }
    }, [isMobile, mobileView])

    /**
     * seta mobile view caso acesso via url
     */
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        if(searchParams.has('mobileView')){
            setMobileView(searchParams.get('mobileView'));
        }
    }, [location.search])

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        if(!isMobile && searchParams.has('mobileView')){
            setMobileView(null);
        }
    }, [isMobile, location.search]);

    useEffect(() => {
        setRenovar(
            user.renovar &&
                !user.expirado &&
                localStorage.getItem('msg_shwnd') == '1',
        );
        localStorage.removeItem('msg_shwnd');
    }, [user]);

    useEffect(() => {
        if (props.loadingRx) {
            return;
        }

        const hasOpenModal = !!document.querySelector('.modal.show');
        if (hasOpenModal) {
            return;
        }

        // Defensive cleanup for stale modal scroll lock after route/search updates.
        document.body.classList.remove('modal-open');
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('padding-right');
        document.documentElement.style.removeProperty('overflow');

        document.querySelectorAll('.modal-backdrop').forEach(backdrop => {
            backdrop.parentNode?.removeChild(backdrop);
        });
    }, [props.loadingRx, location.pathname, location.search]);

    /**
     * Busca as seções
     */
    useEffect(() => {
        const cancelTokenSrc = Axios.CancelToken.source();
        CatalogoAPI.buscarSecoes(props.guiaSelecionada, 'C', cancelTokenSrc.token).then((response) => {
            if(response){
                const { data } =  response;
                if(data){
                    setSectionsData(data)
                    return;
                }
            }
            setSectionsData(null)
        }).catch((error) => {
            if(!Axios.isCancel(error)){
                APIHelper.tratarErro(error)
                console.log('Error on request sections')
            }
        })
        return () => cancelTokenSrc.cancel();
    }, [props.guiaSelecionada])

    const renovarValidade = () => {
        navigate('/meupergamum/dados-pessoais');
    };

    const { t } = useTranslation();
    const [top, setTop] = useState(false);

    const getContnt = useMemo(() => {

        switch (view){
            case 'LIBRARY_DETAILS':
                return (<div className='bkbranco w-100'>
                        <ContentDetails />
                </div>)
            default:
                return (<>
                    <Div
                        className="body"
                        // Removido em 19/09/2023 por solicitação dos bibliotecários
                        // onLoad={ref => {
                        //     ref.scrollIntoView({
                        //         block: 'start',
                        //         inline: 'nearest',
                        //         behavior: 'smooth',
                        //     });
                        // }}
                    >
                        {props.children}
                    </Div>

                    {
                        showHighlights && sectionsData !== null && sectionsData?.length > 0  ?  (
                            <Secoes secoes={sectionsData} guiaSelecionada={props.guiaSelecionada} />
                        ) : ''
                    }

                    {extras && (
                        <>
                            <GuiasConteudoPersonalizado />
                            <InfoAsks />
                        </>
                    )}
                    {/* Novo botão para ir ao topo*/}
                    <Go2Top
                        onClick={() =>
                            document.querySelector('#content').scrollIntoView({
                                block: 'start',
                                inline: 'nearest',
                                behavior: 'smooth',
                            })
                        }
                        visible={top}
                        t={t}
                    />
                    {/* 10/01 - Novo rodapé */}
                    <Footer showLinks />
                </>)
        }


    }, [view, extras, showHighlights, top, props.children, props.guiaSelecionada, sectionsData])


    return (
        <AccessibilityContextProvider>
            <div  ref={contentRef}>
                {
                    isMobile ? (
                        <div
                            style={{
                                height: 'auto',
                                minHeight: '100vh',
                            }}
                            id="content"
                            className={LayoutHelper().getRootClasses(
                                props?.instituicaoRx,
                                props?.acessibilidadeRx,
                            )}
                        >
                            <MobileLayout
                                {...props}
                                showSearchBar={showSearchBar}
                            />
                        </div>
                    ) : (
                        <div
                            id="content"
                            className={LayoutHelper().getRootClasses(
                                props.instituicaoRx,
                                props.acessibilidadeRx,
                            )}
                        >
                            <AccessibilityBar />
                            <AutoAtendimento/>
                            <ModalConstructor open={props.loadingRx} size="xs">
                                <div className="p-4 text-center">
                                    {props.loadingRx && (
                                        <div>
                                            <SpinnerConstructor
                                                visible
                                                height={60}
                                                width={60}
                                                className="apergamum"
                                            />
                                            <div className="mt-3">
                                    <span className="preto70 s17 f400">
                                        {t('PesquisandoAguarde')}
                                    </span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </ModalConstructor>
                            <ModalConstructor
                                open={renovar}
                                size="xs"
                                title={t('Atencao')}
                                footer={<>
                                    <Button
                                        className="bkverde branco b-none sverde hover hpreto pad5 rad5 t10 r10 f770 s13"
                                        onClick={() => renovarValidade()}
                                    >
                                        {t('Sim')}
                                    </Button>
                                    <Button
                                        className="bkazul branco b-none sazul hover hpreto pad5 rad5 t10 l20 f770 s13"
                                        onClick={() => setRenovar(false)}
                                    >
                                        {t('Nao')}
                                    </Button>
                                </>}
                            >
                                <div className="px-4">
                                    {props.instituicaoRx.msg_renovacao_consulta || (
                                        <>{t('msg_renovacao_consulta')}</>
                                    )}
                                </div>
                            </ModalConstructor>

                            <div className="" style={{ position: 'relative', zIndex: '1' }}>
                                <div
                                    className="d-none d-md-block"
                                    style={{ position: 'absolute', width: '100%' }}
                                >
                                    <a
                                        href={
                                            props.instituicaoRx.link_logo_consulta
                                                ? props.instituicaoRx.link_logo_consulta
                                                : '/'
                                        }
                                        className="img_logo d-none d-sm-block"
                                        style={{
                                            backgroundImage:
                                                logoById !== null ? `url(${logoById.logo_consulta})` : `url(${process.env.REACT_APP_URL}/imagens/logo)`,
                                            backgroundColor: logoById !== null ? `rgba(${logoById.logo_consulta_cor_fundo}, ${logoById?.logo_consulta_opacidade ?? 1}%)` : StyleHelper.getColor(props.instituicaoRx?.cor_fundo_logotipo_consulta, props.instituicaoRx?.logotipo_consulta_opacidade ?? 1),
                                        }}
                                        target={
                                            props.instituicaoRx.link_logo_consulta
                                                ? '_blank'
                                                : '_self'
                                        }
                                    >
                                        <span className="sr-only">Logo</span>
                                    </a>

                                    <MenuUsuario />
                                </div>
                                <div
                                    className="img_topo_biblioteca bktema"
                                    style={{
                                        backgroundImage: `url(${process.env.REACT_APP_URL}/imagens/background)`,
                                        backgroundSize: 'cover',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: 'center top',
                                    }}
                                >
                                    {/* Área de pesquisa */}
                                    {showSearchBar && (
                                        <SearchBar
                                            opcoesConsulta={props.opcoesConsultaRx}
                                            guiaSelecionada={props.guiaSelecionada}
                                        />
                                    )}
                                </div>
                            </div>
                            {getContnt}
                        </div>
                    )
                }
            </div>
        </AccessibilityContextProvider>
    );
}

const mapStateToProps = state => ({
    opcoesConsultaRx: state.pesquisa.opcoesConsulta,
    instituicaoRx: state.instituicao.data,
    acessibilidadeRx: state.pageConfig.acessibilidade,
    userSessionRx: state.auth.user,
    userLocalRx: state.authPersist.user,
    loadingRx: state.pageConfig.loading,
    guiasPesquisa: state.pageConfig.guiasPesquisa,
    logoById: state.pageConfig.logoById,
    view: state.pageConfig.view
});

export default connect(mapStateToProps)(
    MiddlewareLogin(BaseTemplate),
);
